import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchUngroupedDevices, fetchDeviceGroups, setPageTitle, updateDevice } from 'signoxe/actions';
import { DeviceView,Page } from 'signoxe/components';
import { getDeviceGroups, getUnassignedDevices } from '../../../../selectors';
import './styles.scss';


// THIS PAGE CONTAINS DEVICES WHICH HAVE NOT BEEN ASSIGNED TO A GROUPED OR UNGROUPED DEVICE WRAPPER, 
class UnassignedDevices extends React.Component {
  static propTypes = {
    devices: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    fetchUngroupedDevices: PropTypes.func.isRequired,
    fetchDeviceGroups: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setPageTitle('Unassigned Devices');
    // this.props.fetchUngroupedDevices()
  }

  render() {
    const {devices, groups, onChange, fetchDeviceGroups} = this.props;

    return (
      <Page>
        <table className="unassigned-device-list">
          <thead>
          <tr className="list-headings">
            <th  className='hide-for-small-only' >Device Name</th>
            {devices.length > 0 && (devices[0].delay_download && <th>Device State</th>)}
            <th className='hide-for-small-only'>Last Ping</th>
            <th  className='hide-for-small-only'>Change Group</th>
          </tr>
          </thead>
          <tbody>
          {devices.map(device =>
            (<DeviceView key={device.device_id}
              device={device}
              groupList={groups}
              onChange={(device) => { onChange(device.id, device); this.props.fetchDeviceGroups()  }}/>
            ),
          )}
          </tbody>
        </table>
      </Page>
    );
  }
}

export default connect((state) => ({
    devices: getUnassignedDevices(state),
    groups: getDeviceGroups(state),
  }), {
    fetchUngroupedDevices,
    fetchDeviceGroups,
    onChange: updateDevice,
    setPageTitle,
  },
)(UnassignedDevices);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DevicesPage/tabs/UnassignedDevices/UnassignedDevicesView.js